import { useEffect, useRef } from 'react'
import { subscribeToBroadcastType } from 'utils/broadcastChannel'

/**
 * Subscribe to a cross-tab BroadcastChannel message type.
 * Own-tab messages are ignored. Pass `{ enabled: false }` to pause.
 */
export const useBroadcastMessage = (messageType, onMessage, { enabled = true } = {}) => {
  const onMessageRef = useRef(onMessage)

  onMessageRef.current = onMessage

  useEffect(() => {
    if (!enabled || !messageType) {
      return undefined
    }

    return subscribeToBroadcastType(messageType, (data) => {
      if (onMessageRef.current) {
        onMessageRef.current(data)
      }
    })
  }, [enabled, messageType])
}
